import FAQLinks from '@/modules/User/statics/faqLinks';
import ProductType from '@/statics/productType';
import i18n from '@/helper/i18n';
import { BASIC_CREDITOR_VOUCHER_TYPE_GROUPS } from '@/modules/User/statics/creditorVoucherType';
import { BASIC_VOUCHER_STATUS_TO_SHOW_GROUPS } from '@/statics/voucherStatusToShow';
import { BASIC_VOUCHER_SUB_STATUS_FILTER_OPTIONS } from '@/statics/voucherSubStatus';
import { BASIC_VOUCHER_TYPE_GROUPS } from '@/statics/voucherType';
import { BILLING_PERMISSIONS } from '@/statics/productPermissions';

import {
  ASSET_CONSULTANT,
  ASSET_CONSULTANT_NUMBER,
  CREDITOR_LIMIT,
  DEPARTMENT,
  FACTORABLE_TURNOVER,
  FOUNDING_DATE,
  INTERMEDIARY_NUMBER,
  ONLINE_TURNOVER_RATE,
  VOB
} from '@/helper/createCreditorFactory';
import {
  IMPRINT_FINTECRITY,
  PRIVACY_POLICY_FINTECRITY,
  PRODUCT_INFO_FINTECRITY,
  REQUEST_MAIL_FINTECRITY,
  SERVICE_HOTLINE_FINTECRITY,
  SERVICE_MAIL_FINTECRITY
} from '@/statics/customerServiceInformation';

const PRODUCT_NAME = 'FinRechnung';

const FAS_BILLING_CONFIG = {
  type: ProductType.FAS_BILLING,
  productName: PRODUCT_NAME,
  portalName: 'FinTecrity-Portal',
  logo: require('@/assets/FinTecrity-logo.svg'),
  favIcon: '/favicons/faviconFinTecrity.ico',
  theme: 'fintecrity' /* matches key of $theme-fintecrity in styles/themes/index.scss */,
  background: null,
  placeLogoInHeader: false,
  serviceHotline: SERVICE_HOTLINE_FINTECRITY,
  serviceMail: SERVICE_MAIL_FINTECRITY,
  requestMail: REQUEST_MAIL_FINTECRITY,
  infoUrl: PRODUCT_INFO_FINTECRITY,
  privacyPolicyUrl: PRIVACY_POLICY_FINTECRITY,
  imprintUrl: IMPRINT_FINTECRITY,
  withPurchaseAssurance: false,

  voucherStatusToShowGroups: BASIC_VOUCHER_STATUS_TO_SHOW_GROUPS,
  voucherSubStatusFilter: BASIC_VOUCHER_SUB_STATUS_FILTER_OPTIONS,
  voucherTypeGroups: BASIC_VOUCHER_TYPE_GROUPS,
  creditorVoucherTypeGroups: BASIC_CREDITOR_VOUCHER_TYPE_GROUPS,

  permissions: {
    ...BILLING_PERMISSIONS,
    dashboard: {
      ...BILLING_PERMISSIONS.dashboard,
      cashback: false
    }
  },

  onboarding: {
    blacklist: [
      ONLINE_TURNOVER_RATE,
      FACTORABLE_TURNOVER,
      CREDITOR_LIMIT,
      FOUNDING_DATE,
      VOB,
      INTERMEDIARY_NUMBER,
      ASSET_CONSULTANT,
      DEPARTMENT
    ],
    rules: {
      [ASSET_CONSULTANT_NUMBER]: 'required|digits:6'
    },
    setUpFeeValues: [49900, 24900, 0]
  },

  faq: [FAQLinks.DEBTORS, FAQLinks.ENCASHMENT],

  documents: {
    masterData: [
      {
        title: i18n.t('masterData.dataProtectionRegulation'),
        path: '/assets/masterData/APL/FTY_Datenschutzhinweise_Art.13 14_092024.pdf'
      },
      {
        title: i18n.t('masterData.productSpecificDataProtectionRegulation'),
        path: '/assets/masterData/FAS/FTY_Datenschutz ergänzend_FinRechnung_2024-09.pdf'
      },
      {
        title: i18n.t('masterData.infoChangeBankDetails'),
        path: '/assets/masterData/APL/Bankdatenänderung_FTY_2024.pdf'
      },
      {
        title: i18n.t('masterData.notificationLetter'),
        path: '/assets/masterData/APL/Notifikationsschreiben_Zusammenarbeit_FinTecrity.docx'
      }
    ],

    sepa: {
      template: {
        title: i18n.t('permanentDebts.pdf.sepaTemplate'),
        path: '/assets/sepa/Vorlage_Einzugsermächtigung.pdf'
      }
    },

    upload: {},

    templates: {
      word: '/assets/templates/APL/Muster_Debitorenrechnung.docx',
      excel: '/assets/templates/APL/Muster_Debitorenrechnung.xlsx'
    }
  },

  translations: {
    onboarding: {
      assetConsultantNumber: '@:onboarding.intermediaryNumberFull',
      assetConsultantData: '@:onboarding.intermediaryData'
    }
  }
};

export default FAS_BILLING_CONFIG;
